export const CS_CALL_CLIENT = 'CS_CALL_CLIENT'
export const CS_MEET_CLIENT = 'CS_MEET_CLIENT'
export const CS_ISSUE = 'CS_ISSUE'
export const CS_ISSUANCE_CAR = 'CS_ISSUANCE_CAR'
export const CS_ISSUE_MANAGER = 'CS_ISSUE_MANAGER'
export const MISSING = 'MISSING'
export const typesNames = {
  CS_CALL_CLIENT: 'Связаться с клиентом',
  CS_MEET_CLIENT: 'Встреча с клиентом',
  CS_ISSUE: 'Подготовка к выдаче',
  CS_ISSUANCE_CAR: 'Выдача авто',
  CS_ISSUE_MANAGER: 'Подготовка на выдачу менеджером'
}

export const EVENT_TYPE = [
  {
    code: CS_CALL_CLIENT,
    name: typesNames[CS_CALL_CLIENT]
  },
  {
    code: CS_MEET_CLIENT,
    name: typesNames[CS_MEET_CLIENT]
  },
  {
    code: CS_ISSUE,
    name: typesNames[CS_ISSUE]
  }
]
export const EVENT_TYPE_FILTER = [
  {
    code: CS_CALL_CLIENT,
    name: typesNames[CS_CALL_CLIENT]
  },
  {
    code: CS_MEET_CLIENT,
    name: typesNames[CS_MEET_CLIENT]
  },
  {
    code: CS_ISSUE_MANAGER,
    name: typesNames[CS_ISSUE_MANAGER]
  }
]
export const ROP_EVENT_TYPE = [
  {
    code: CS_CALL_CLIENT,
    name: typesNames[CS_CALL_CLIENT]
  },
  {
    code: CS_MEET_CLIENT,
    name: typesNames[CS_MEET_CLIENT]
  },
  {
    code: CS_ISSUE,
    name: typesNames[CS_ISSUE]
  },
  {
    code: CS_ISSUE_MANAGER,
    name: typesNames[CS_ISSUE_MANAGER]
  }
]
